<template>
  <div class="documentIndex" v-loading="loading">
    <!-- <Bread></Bread> -->
    <div class="content" style="margin-top: 20px">
      <div class="platform" style="display: flex;justify-content: space-between;">
        <!-- <div>平台当前上传识别人数共 {{ userObj.userNum }} 位，</div>
                <div>平台待处理图片 {{ userObj.pictureNum }} 张</div> -->
        <div>剩余页数： <span style="font-size: 18px;
                    font-weight: 550;
                    color: #c10000;">{{ totalPage }}</span> <i> 页</i></div>
        <div>登录人次： <span style="font-size: 18px;
                        font-weight: 550;
                        color: #c10000;">{{ loginRecordSum }}</span> <i></i></div>
      </div>
      <uploadFile @getList="getList" id="step1"></uploadFile>
      <div class="handles">
        <div class="startButton">
          <!-- <startVerify @on-pass="startClick" :selection="selection" style="margin-right: 7px;"></startVerify> -->
          <deleteAll :deleteSelection="deleteSelection" @on-deleteAll="deleteFinish"></deleteAll>
          <el-dropdown @command="clickFn" id="step4">
            <el-button type="primary">
              导出<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="fileToPdf">导出文件</el-dropdown-item>
              <!-- <el-dropdown-item command="excelToPdf">导出Excel为PDF</el-dropdown-item> -->
              <el-dropdown-item command="fileToFiled">导出字段</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="right">
          <searchFile @on-search="onSearch" @on-clear="onClear" :wenan="wenan"></searchFile>
          <el-date-picker v-model="dateValue" type="daterange" range-separator="～" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" @change="dateChange">
          </el-date-picker>
        </div>
      </div>
      <!-- 表格组件 https://xuliangzhan_admin.gitee.io/vxe-table/#/table/api -->
      <!-- 进度条 https://github.com/usablica/progress.js/wiki/API -->
      <!-- show-overflow -->
      <vxe-table v-loading="tableLoading" highlight-hover-row row-id="seqNo" :row-key="false" ref="xTree"
        @cell-click="cellClickEvent" :tree-config="{
                lazy: true,children: 'children',hasChild: 'hasChildren',line: true,
                expandRowKeys: defaultExpandRowKeys,loadMethod: lazyLoadTable}" :row-class-name="tableRowClassName"
        :checkbox-config="{labelField: 'resName',checkMethod}"
        :sort-config="{trigger: 'cell', defaultSort: {field: 'uploadTime', order: 'desc'}}" :data="tableData"
        class="docs_table" width="100%" @toggle-tree-expand="toggleTreeExpand" @checkbox-change="selectChangeEvent"
        @checkbox-all="checkboxAll">
        <vxe-table-column type="checkbox" title="ElInput" width="400" tree-node :edit-render="{name: 'ElInput'}"
          show-overflow="ellipsis" fixed="left">
          <template v-slot:header="{ column }" min-width="25%">
            <span>文件序号</span>
            <span class="single-title">文件名</span>
          </template>
          <template v-slot="{row}">
            <el-tooltip class="item" effect="dark"
              :content="row.resName.substr(0,row.resName.lastIndexOf('.'))+'.'+row.format.toLocaleLowerCase()"
              placement="top">
              <span>
                <span class="file-id" :class="{grey: row.tempFile}">{{ row.tempFile ? '' : row.seqNo
                  }}</span>
                <span class="file-name" :class="{grey: row.tempFile}">{{ row.resName.substr(0,
                  row.resName.lastIndexOf('.')) }}</span>
                <span class="file-format" :class="{grey: row.tempFile}">.{{
                  row.format.toLocaleLowerCase() }}</span>
                <em class="file-size">{{ row.sizeWithUnit.toUpperCase() }}</em>
              </span>
            </el-tooltip>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="seqNo" title="文件序号">
                    <template v-slot="{row}">
                        <span :title="row.seqNo" class="file-id" :class="{grey: row.tempFile}">{{row.tempFile ? '' : row.seqNo}}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="resName" title="文件名" width="60"  show-overflow="title">
                    <template v-slot="{row}">
                        <span :title="row.resName" class="file-name" :class="{grey: row.tempFile}">{{row.resName.split('.')[0]}}</span>
                        <span class="file-format" :class="{grey: row.tempFile}">.{{row.format}}</span>
                        <em class="file-size">{{row.sizeWithUnit.toUpperCase()}}</em>
                    </template>
                </vxe-table-column> -->
        <vxe-table-column field="category" title="单证类型" min-width="15%" show-overflow="tooltip">
          <template v-slot="{row}">
            <template v-if="row.category === '' || row.category === 0">
              <span class="null">-</span>
            </template>
            <template v-else>
              <span>{{ row.category }}</span>
            </template>
          </template>
        </vxe-table-column>
        <vxe-table-column field="" title="进度" width="150px" show-overflow="tooltip">
          <template v-slot="{row}">
            <tableSocketProcess :row="row"></tableSocketProcess>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="" title="识别结果" width="150px">
                    <template v-slot="{row}">
                        <tableSocketResult :row="row" :count="row.recognitionCount"></tableSocketResult>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="customerName" title="归属客户" min-width="12%" show-overflow="ellipsis">
                    <template v-slot="{row}">
                        <template>
                            <span>{{row.customerName}}</span>
                        </template>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="customerCode" title="客户代码" min-width="10%" show-overflow="ellipsis">
                    <template v-slot="{row}">
                        <template>
                            <span>{{row.customerCode}}</span>
                        </template>
                    </template>
                </vxe-table-column> -->
        <vxe-table-column field="uploadTime" title="上传时间" sortable min-width="15%">
          <template v-slot="{row}">
            <span>{{ row.uploadTime && row.uploadTime.split(' ')[0] }}</span>
            <span style="margin-left: 10px;">{{ row.uploadTime && row.uploadTime.split(' ')[1].substr(0, 5)
              }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="" title="操作" width="100px" fixed="right">
          <template v-slot="{row}">
            <!-- 查看结果+删除 -->
            <span id="step2" style="color:#16336C;font-size:14px;cursor: pointer;" @click="resultInfo(row)">查看结果</span>
            <!-- <div class="shugang"></div> -->
            <!-- <tableDataDelete v-if="row.status && !row.status.includes('识别完成')" :row="row"
                            @on-delete="deleteFinish">
                        </tableDataDelete> -->
          </template>
        </vxe-table-column>
      </vxe-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]"
        :page-size="condition.limit" :total="total" @size-change="sizeChange" :current-page.sync="currentPage"
        @current-change="pageCurrentChange"></el-pagination>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import _ from 'lodash'

  import Bread from '../common/Bread'
  import searchFile from '../common/searchFile'
  import uploadFile from './uploadFile'
  import deleteAll from './deleteAll'
  import tableSocketProcess from './tableSocketProcess'
  import tableSocketResult from './tableSocketResult'
  import tableDataDelete from './tableDataDelete'
  import docType from '@/assets/js/mixin/docType'
  // import startVerify from './startVerify'
  import cont from '@/assets/js/cont'

  export default {
    name: 'DocesIndex',
    mixins: [docType],
    props: {},
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        },
        englishDoc: false,
        tableData: [],
        total: 0,
        currentPage: 1,
        subNodeList: [],
        threeNodeList: [],
        defaultExpandRowKeys: [],
        dialogVisible: false,
        noteVisible: false,
        dateValue: null,
        currentRow: 0,
        websoketIds: [],
        selection: [],
        searchText: '',
        deleteSelection: [],
        userObj: {
          userNum: 0,
          pictureNum: 0
        },
        failTimes: 0,
        wenan: '请输入文件序号/文件名/单证类型进行查询',
        verifyList: [],
        loading: false,
        condition: {
          limit: 10
        },
        tableLoading: false,
        headResId: null,
        totalPage: 0,
        loginRecordSum: 0,
        listQuery: {
          pageNo: 1,
          pageSize: 10,
          overdue: undefined,
          exhausted: undefined,
          orgCode: undefined,
          oprUser: undefined
        },
        orgCode: JSON.parse(localStorage.getItem('orgCode')).value,
        username: localStorage.getItem('BAILIAN-SHIBIE-USERNAME'),
        introOption: cont.introOption
      }
    },
    computed: {
      ...mapState(['labelState']),
      ...mapGetters(['localPage', 'docTypeNum', 'demoFlag'])
    },
    watch: {
      // tableData:{
      //   handler: function(val, oldVal) {
      // 		console.log('图片类不显示类型')
      // 	},
      // 	deep: true
      // },
      $route(to, from) {
        this.docModel()
        if (to.path.includes('endoc')) {
          this.getUploadList()
        } else {
          this.getUploadList()
        }
        if (from.name === 'artificial' || from.name === 'editpage') {
          this.getUploadList()
        }
      },
      demoFlag(v) {
        this.initGuide() // 调用新手引导的方法
      }
    },
    created() {
      this.getList()
    },
    mounted() {
      // this.$message({
      //     message: '恭喜你，这是一条成功消息',
      //     type: 'info',
      //     duration: 30000000
      // });

      this.passportVerify()
    },
    //   activated(){
    //     	that.$forceUpdate()
    //   },
    destroyed() {
      //注销后清除缓存
      // this.removeLocal();
      this.$intro().exit()
    },
    methods: {
      initGuide() {
        if (this.demoFlag) {
          this.$nextTick(() => {
            if (this.tableData.length > 0) {
              if (this.$route.query.export) {
                this.introOption.steps = [
                  { title: '勾选', element: document.querySelector('.vxe-tree-cell'), intro: `勾选需要导出的数据，支持多项一起勾选` },
                  { title: '导出', element: '#step4', intro: `可以导出文件和导出字段` }
                ]
              } else {
                this.introOption.steps = [
                  { title: '开始识别', element: '#step1', intro: `点击上传需要识别的文件，支持拖拽上传` },
                  { title: '查看结果', element: '#step2', intro: `点击查看识别结果` }
                ]
              }
            } else {
              this.introOption.steps = [
                { title: '开始识别', element: '#step1', intro: `点击上传需要识别的文件，支持拖拽上传` },
              ]
            }
            this.$intro()
              .setOptions(this.introOption)
              // 点击结束按钮后执行的事件
              .oncomplete(() => {
                //console.log('点击结束按钮后执行的事件')
                this.$store.dispatch('setDemoFlag', false);
                if (this.$router.query) {
                  this.$router.query.expprt = false
                }
                // bus.$emit('toTeachPage', 2);
              })
              // 点击跳过按钮后执行的事件
              .onexit(() => {
                //console.log('点击跳过按钮后执行的事件')
                this.$store.dispatch('setDemoFlag', false);
              })
              // 确认完毕之后执行的事件
              .onbeforeexit(() => {
                //console.log('确认完毕之后执行的事件')
                this.$store.dispatch('setDemoFlag', false);
              })
              .start()
          })
        }
      },
      getList(param) {
        if (param) {
          this.listQuery.pageNo = param.pageNo
          this.listQuery.pageSize = param.pageSize
        }
        this.listQuery.orgCode = this.orgCode
        this.listQuery.oprUser = this.username
        this.$axios({
          url: this.$resource.tOrgAccountPage.replace('{pageNo}', this.listQuery.pageNo).replace('{limit}', this.listQuery.pageSize),
          method: 'POST',
          data: this.listQuery
        })
          .then(res => {
            const bl = this.$utils.ajaxResponse.call(this, res)
            if (bl) {
              this.totalPage = res.data.data.list[0].totalSum
              this.loginRecordSum = res.data.data.list[0].loginRecordSum
            } else {
              this.$message.error(res.data.msg);
            }

          })
      },
      //查看结果功能
      resultInfo(item) {
        let obj = JSON.stringify({
          id: item.id,
          name: item.resName,
          flag: true,
          search: 'success',
          hasChildren: item.hasChildren,
          pId: item.id,
          type: this.$route.name.split('-')[0]
        })
        this.$router.push({
          path: 'successPageRecog',
          query: {
            id: item.id,
            name: item.resName,
            flag: true,
            search: 'success',
            hasChildren: item.hasChildren,
            pId: item.id,
            type: this.$route.name.split('-')[0],
            params: obj
          }
        })

        return false
      },
      async passportVerify() {
        // 从官网登陆过来增加token,存入header
        let token = this.$route.query.token
        if (token) {
          localStorage.setItem(
            'BAILIAN-SHIBIE-OFFICEWEBSITE-TOKEN',
            token
          )

          let url = this.$resource.getCurrentUser
          let res = await this.$axios({
            url: url,
            method: 'get'
          })

          localStorage.setItem(
            'BAILIAN-SHIBIE-USERNAME',
            res.data.data.nickName
          )
          this.$store.dispatch('setUserName', res.data.data.nickName)
        }

        if (this.$route.path.includes('endoc') === true) {
          this.englishDoc = true
        } else {
          this.englishDoc = false
        }

        this.getTaskStatus()

        this.$store.dispatch('setFullExpand', 'icon-expandout')

        this.getUploadList(this.localPage)
      },
      getTaskStatus() {
        // 查询平台当前上传识别人数
        let url = this.$wsUrl + this.$resource.taskStatus

        const ws = new WebSocket(url)

        // 连接后监听
        ws.onopen = () => {
          console.log('websocket,taskStatus已打开', ws.readyState)
          // ws.send('Ping');
        }

        //获得消息事件
        ws.onmessage = msg => {
          if (msg.data === '连接成功') {
            // ws.send('连接成功' + id);
          }

          if (msg.data !== '连接成功') {
            let obj = JSON.parse(msg.data)
            this.userObj = obj
          }
        }
        // 监听连接关闭
        ws.onclose = data => {
          if (this.failTimes >= 5) {
            return
          }

          // 递归重连websoket
          setTimeout(() => {
            this.failTimes++
            this.getTaskStatus()
          }, 2000)
          //console.log('websocket,taskStatus已关闭', data)
          console.log('websocket,taskStatus已关闭')
        }
        //发生了错误事件
        ws.onerror = () => {
          if (this.failTimes >= 5) {
            return
          }

          // 递归重连websoket
          setTimeout(() => {
            this.failTimes++
            this.getTaskStatus()
          }, 2000)
          //console.log('websocket发生了错误')
          //此时可以尝试刷新页面
        }
      },
      getUploadList(page = 1, searchText, date = ['', '']) {
        this.tableLoading = true
        if (date === null) {
          date = ['', '']
        }
        // console.log(radio, searchText, date)
        let url = this.$resource.listUploadList
          .replace('{pageNum}', page)
          .replace('{pageSize}', this.condition.limit)
          .replace('{parentId}', 0)
        this.$axios({
          url: url,
          // url: 'http://localhost:8080/index.json',
          method: 'post',
          params: {},
          timeout: 1000 * 60,
          transformResponse: [
            function (data) {
              // 对 data 进行任意转换处理
              let result = JSON.parse(data)
              if (result.code === '401') {
                return
              }
              result.data.list &&
                result.data.list.forEach(item => {
                  if (item.category == 0) {
                    item.category = ''
                  }

                  //新增属性
                  item.random = 0
                })
              return result
            }
          ],
          data: {
            content: searchText,
            beginTime: date[0],
            endTime: date[1],
            type: this.englishDoc ? 1 : 3,
            orgCode: JSON.parse(localStorage.getItem('orgCode')).value
          }
        })
          .then(res => {
            this.tableLoading = false
            this.$refs.xTree.clearTreeExpand()

            this.total = res.data.data.total
            this.tableData = res.data.data.list
            this.initGuide()
            this.currentPage = this.localPage

            //刷新页面，保证连接ws
            this.tableData.forEach(item => {
              let status = item.status.split('_')[1]
              if (
                status === '等待转换' ||
                status === '正在转换' ||
                status === '正在分类' ||
                status === '等待分类' ||
                status === '正在识别'
              ) {
                //未识别成功，不允许展开子集
                item.hasChildren = false

                // 保持进度中继续
                let name = 'BAILIAN-SHIBIEUPLOAD-' + item.id
                this.getItem(name, item)

                this.getWebsocket(item.id, 'refresh')
              }
            })

            // this.tableData.unshift({
            //     tempFile: true,
            //     category: '-',
            //     format: 'pdf',
            //     seqNo: Math.floor(Math.random() * 300),
            //     id: Math.floor(Math.random() * 300),
            //     recognitionCount: {},
            //     level: 1,
            //     resName: 'eeee.pdf',
            //     size: 333333 / 1024,
            //     sizeWithUnit: (33333333 / 1024).toFixed(2) + 'K',
            //     status: "正在上传中",
            //     uploadTime: '2020-02-29 12:01:50',
            //     uploadUser: "",
            //     predictCost: 9,
            //     count: 0,
            //     uploadTrip: 0,
            //     uploadCo: 0,

            // })
          })
          .catch(e => {
            this.tableLoading = false
            console.log(e)
          })
      },
      pageCurrentChange(x) {
        this.$store.dispatch('setLocalPage', x)
        this.currentPage = x

        this.getUploadList(x, this.searchText, this.dateValue)
      },
      sizeChange(limit) {
        this.$store.dispatch('setLocalPage', 1)
        this.condition.limit = limit
        this.getUploadList(1, this.searchText, this.dateValue)
      },
      checkMethod({ row }) {
        return row
      },
      removeLocal() {
        Object.keys(localStorage).forEach(item => {
          item.indexOf('BAILIAN-SHIBIEUPLOAD-') != -1
            ? localStorage.removeItem(item)
            : ''
        })
      },
      getItem(name, row) {
        let count = this.$utils.storage(name)
        if (count) {
          progressJs('#uploadProgress_' + row.id)
            .setOptions({ overlayMode: false })
            .set(count)
        }
      },
      toggleTreeExpand({ expanded, row, rowIndex }, event) {
        //上传的开始阶段，点击没反应执行重新加载，row,children获取不到
        if (row.children && row.children.length === 0) {
          this.$refs.xTree.reloadTreeChilds(row)
        }
        // if (this.subNodeList.length > 0) {
        //     this.subNodeList.forEach(item => {
        //         this.websoketIds.push(item.id);
        //     })

        //     this.websoketIds = _.uniq(this.websoketIds);
        //     this.websoketIds.forEach(item => {
        //         this.getWebsocket(item);
        //     })
        // }
      },
      lazyLoadTable({ row }) {
        // 未识别完成，文件不能展开
        if (row.hasChildren === false) {
          return
        }
        let url = this.$resource.listUploadList
          .replace('{pageNum}', 1)
          .replace('{pageSize}', 600)
          .replace('{parentId}', row.id)

        if (row.format === 'zip' || row.format === 'rar') {
          return this.$axios({
            url: url,
            method: 'post',
            params: {},
            transformResponse: [
              function (data) {
                // 对 data 进行任意转换处理
                let result = JSON.parse(data)
                result.data.list &&
                  result.data.list.forEach(item => {
                    if (item.category === 0) {
                      item.category = ''
                    }
                    //新增属性
                    item.random = 0
                  })
                return result
              }
            ]
          })
            .then(res => {
              //二级
              if (res && res.data && res.data.data) {
                let list = res.data.data.list
                this.subNodeList = list

                let x = this.tableData.findIndex(item => {
                  return item.id === row.id
                })
                this.tableData[x].children = list

                if (list.length > 0) {
                  list.forEach(item => {
                    if (item.status && item.status.indexOf('识别成功') < 0) {
                      this.websoketIds.push(item.id)
                    }
                  })

                  let uniqx = _.uniq(this.websoketIds)
                  uniqx.forEach(item => {
                    this.getWebsocket(item)
                  })
                }
                return list
              } else {
                return []
              }
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          return this.$axios({
            url: url,
            method: 'post',
            params: {},
            transformResponse: [
              function (data) {
                // 对 data 进行任意转换处理
                let result = JSON.parse(data)
                result.data.list &&
                  result.data.list.forEach(item => {
                    if (item.category === 0) {
                      item.category = ''
                    }
                    //新增属性
                    item.random = 0
                  })
                return result
              }
            ]
          })
            .then(res => {
              //三级
              if (res.data.data) {
                let list = res.data.data.list
                this.threeNodeList = list

                if (row.level === 1) {
                  let x = this.tableData.findIndex(item => {
                    return item.id === row.id
                  })
                  // console.log(row, list, 0)
                  this.tableData[x].children = list

                  if (list.length > 0) {
                    list.forEach(item => {
                      if (
                        item.status.indexOf('识别成功') < 0
                      ) {
                        this.getWebsocket(item.id)
                      }
                    })
                  }
                }

                return list
              } else {
                return []
              }
            })
            .catch(e => {
              console.log(e)
            })
        }
      },
      async getWebsocket(id, type) {
        if (!id) {
          return
        }

        if (typeof WebSocket == 'undefined') {
          console.log('您的浏览器不支持WebSocket')
        } else {
          console.log('您的浏览器支持WebSocket')
          //实现化WebSocket对象，指定要连接的服务器地址与端口  建立连接

          let url =
            this.$wsUrl +
            this.$resource.websocket.replace('{resId}', id)

          const ws = new WebSocket(url)
          // 心跳计时器
          let heartBeatTimer
          // 连接后监听
          ws.onopen = () => {
            //console.log('websocket,upload已打开', ws.readyState)
            //ws.send("这是来自客户端的消息" + location.href + new Date());
            //每隔5秒钟发送一次心跳，避免websocket连接因超时而自动断开
            heartBeatTimer = window.setInterval(function () {
              //console.log('每隔5秒钟发送一次心跳')
              let ping = {
                type: 'ping'
              }
              ws.send(JSON.stringify(ping))
            }, 5000)
          }

          //获得消息事件
          let count = 0
          ws.onmessage = msg => {
            if (msg.data === '连接成功') {
              // ws.send('连接成功' + id)
            }

            if (msg.data !== '连接成功') {
              let data = JSON.parse(msg.data)
              if (type) {
                count++
                //刷新页面后，只执行一次主动发送
                //console.log(data.status, 'data.status')
                if (
                  count === 1 &&
                  data.status.split('_')[1] !== '识别成功' &&
                  data.status.split('_')[1] !== '识别完成'
                ) {
                  // 发送给后端
                  ws.send(
                    JSON.stringify({
                      resId: id,
                      refresh: true
                    })
                  )
                }
              }

              //父结点
              this.tableData.forEach((item, index) => {
                if (item.id === data.resId) {
                  item.status = data.status
                  if (
                    item.status.split('_')[1] === '分类完成' &&
                    data.recognitionCount &&
                    data.recognitionCount.failed !=
                    data.recognitionCount.total
                  ) {
                    item.recognitionCount = undefined
                  } else {
                    item.recognitionCount =
                      data.recognitionCount
                  }
                  item.category = data.category
                  item.certiNo = data.certiNo
                  item.brand = data.brand
                  item.resId = data.resId
                  item.predictCost = data.predictCost
                  item.templateInfo =
                    data.recognitionCount &&
                    data.recognitionCount.templateInfo
                  // pdf文件结束是识别成功，zip是识别完成
                  if (
                    item.recognitionCount &&
                    (item.status.split('_')[1] === '识别成功' ||
                      item.status.split('_')[1] ===
                      '识别完成' ||
                      item.status.split('_')[1] ===
                      '识别失败')
                  ) {
                    if (
                      item.format === 'jpg' ||
                      item.format === 'jpeg' ||
                      item.format === 'png' ||
                      item.format === 'doc' ||
                      item.format === 'docx'
                    ) {
                      item.hasChildren = false
                    } else {
                      // 识别成功允许展开表下拉
                      item.hasChildren = true
                    }
                  } else {
                    //宝马.pdf文件识别失败，一直不能查看子集，采取的强硬措施
                    // item.hasChildren = false;
                    item.hasChildren = true
                  }
                } else {
                  //展开的子结点
                  if (item.children && item.children.length > 0) {
                    item.children.forEach(child => {
                      if (child.id === data.resId) {
                        child.status = data.status
                        child.predictCost = data.predictCost
                        child.recognitionCount =
                          data.recognitionCount
                        child.templateInfo =
                          data.recognitionCount &&
                          data.recognitionCount
                            .templateInfo
                        child.category = data.category
                        child.certiNo = data.certiNo
                        child.brand = data.brand
                        child.resId = data.resId
                      }
                    })
                  }
                }
              })
            }
            // this.getList()
          }
          // 监听连接关闭
          ws.onclose = data => {
            //console.log('websocket,upload已关闭', data)
            // 关闭定时器
            clearInterval(heartBeatTimer)
          }
          //发生了错误事件
          ws.onerror = () => {
            //console.log('websocket发生了错误')
            // 关闭定时器
            clearInterval(heartBeatTimer)
            //此时可以尝试刷新页面
          }
          // sendBtn.onclick = () => {
          //     // 点击发送按钮。将数据发送给服务端
          //     ws.send(msgBox.value)
          // }
          // exit.onclick = () => {
          //     // 客户端主动关闭连接
          //     ws.close()
          // }
        }
      },
      tableRowClassName({ seq, row, rowIndex, $rowIndex }) {
        // 树形表格样式区分
        if (row.tempFile) {
          return 'child-row--temp'
        }
        if (row.level === 1) {
          return 'child-row--level-1'
        }
        if (row.level === 2) {
          if (row.first === true && row.last === true) {
            return 'child-row--level-2 first-row first-row-one'
          }
          if (row.first === true && row.last === false) {
            return 'child-row--level-2 first-row'
          }
          if (row.last === true) {
            return 'child-row--level-2 last-row'
          }

          return 'child-row--level-2'
        }
        if (row.level === 3 && row.format === 'pdf') {
          if (row.first === true && row.last === true) {
            return 'child-row--level-3-no first-row first-row-one'
          }
          if (row.first === true && row.last === false) {
            return 'child-row--level-3-no first-row'
          }
          if (row.last === true) {
            return 'child-row--level-3-no last-row'
          }
          return 'child-row--level-3-no'
        }
        if (row.level === 3) {
          if (row.first === true && row.last === true) {
            return 'child-row--level-3 first-row first-row-one'
          }
          if (row.first === true && row.last === false) {
            return 'child-row--level-3 first-row'
          }
          if (row.last === true) {
            return 'child-row--level-3 last-row'
          }
          return 'child-row--level-3'
        }
        if (row.level === 4) {
          if (row.first === true && row.last === true) {
            return 'child-row--level-4 first-row first-row-one'
          }
          if (row.first === true && row.last === false) {
            return 'child-row--level-4 first-row'
          }
          if (row.last === true) {
            return 'child-row--level-4 last-row'
          }
          return 'child-row--level-4'
        }
        return ''
      },
      onSearch(txt) {
        this.searchText = txt
        this.getUploadList(this.currentPage, txt, this.dateValue)
      },
      onClear() {
        this.searchText = ''
        // this.getUploadList(this.currentPage);
      },
      dateChange(dateFormat) {
        let x
        if (dateFormat === null) {
          x = ['', '']
        } else {
          x = dateFormat
        }
        this.getUploadList(this.currentPage, this.searchText, x)
      },
      async getSubset(selection, type) {
        //选中父元素，如果父元素有子集，就懒加载子集
        for (let item of selection) {
          // type &&
          if (
            (item.hasChildren === true &&
              item.children === null &&
              item.level === 1) ||
            (item.hasChildren === true &&
              item.children === undefined &&
              item.level === 1) ||
            (
              item.hasChildren === true &&
              (!item.children))
          ) {
            let url = this.$resource.listUploadList
              .replace('{pageNum}', 1)
              .replace('{pageSize}', 600)
              .replace('{parentId}', item.id)
            try {
              let res = await this.$axios({
                url: url,
                method: 'post',
                params: {},
                transformResponse: [
                  function (data) {
                    // 对 data 进行任意转换处理
                    let result = JSON.parse(data)
                    result.data.list &&
                      result.data.list.forEach(item => {
                        if (item.category === 0) {
                          item.category = ''
                        }
                        //新增属性
                        item.random = 0
                      })
                    return result
                  }
                ]
              })
              //三级
              if (res.data.data) {
                let list = res.data.data.list
                item.children = list

                // 处理压缩包的选中
                if (
                  selection[0].format === 'zip' ||
                  selection[0].format === 'rar'
                ) {
                  this.getSubset(list, 'zip')
                }
              }
            } catch (e) {
              // statements
              console.log(e)
            }
          }
        }
        await Promise.all(selection);
        return selection;
      },
      async checkboxAll({ selection, reserves, checked }, event) {
        this.selection = await this.getSubset(selection)
        this.deleteSelection = selection
      },
      async selectChangeEvent(
        {
          selection,
          reserves,
          checked,
          row,
          rowIndex,
          $rowIndex,
          column,
          columnIndex,
          $columnIndex,
          cell
        },
        event
      ) {
        this.headResId = row.id
        // this.loading = true
        this.selection = await this.getSubset(selection)
        this.deleteSelection = selection
      },
      deleteFinish() {
        this.getUploadList(this.currentPage)
      },
      startClick() {
        this.$refs.xTree.clearCheckboxRow()
      },
      // deleteFinish() {
      //   this.getUploadList(this.currentPage)
      // },
      cellClickEvent(e) {
        if (e.$columnIndex > 1) {
          this.resultInfo(e.row)
        }
      },
      mergeChildren(objects, v) {
        let mergedObjects = [];
        for (const obj of objects) {
          if (obj.format === 'rar' || obj.format === 'zip') {
            for (const c of obj.children) {
              if (c.hasChildren && c.children.length > 0) {
                mergedObjects = mergedObjects.concat(c.children);
              } else {
                mergedObjects.push(c);
              }
            }
          } else {
            if (obj.hasChildren && obj.children.length > 0) {
              mergedObjects = mergedObjects.concat(obj.children);
            } else {
              mergedObjects.push(obj);
            }
          }
        }
        return mergedObjects;
      },
      deduplicateObjectsByFieldAndFilter(array, field, filterValue, v) {
        const seen = new Set();
        const deduplicatedArray = [];
        for (const obj of array) {
          const fieldValue = obj[field];
          if (obj.category !== filterValue && !seen.has(fieldValue) && !seen.has(obj.pId)) {
            if (v === 'fileToFiled') {
              if (!obj.remark.includes('未匹配')) {
                deduplicatedArray.push(obj);
                seen.add(fieldValue);
              }
            } else {
              deduplicatedArray.push(obj);
              seen.add(fieldValue);
            }
          }
        }
        return deduplicatedArray;
      },
      clickFn(v) {
        let ary = []
        let excelAry = []
        //console.log(this.selection, 'selectionselectionselection')
        let result = this.deduplicateObjectsByFieldAndFilter(this.mergeChildren(this.selection, v), 'id', '未知', v);
        this.verifyStatus = true
        //console.log(result, 'resultresultresultresult')
        if (result.length === 0) {
          this.$message.error('单证类型未匹配成功，无法导出！')
          return
        } else {
          this.verifyList = result
        }
        this.selectCertificate()
          .then(async res => {
            if (res.data.data.msg) {
              this.$message.error(res.data.data.msg)
            } else {
              this.result = res.data.data
              //console.log(res, 'res')
              let secondRes = await this.startCheck(
                res.data.data.waybillInfo.resId
              )
              if (v == 'fileToPdf') {
                this.$router.push({
                  path: '/dashboard/exportFile',
                  query: {
                    recordId: secondRes.data.data.id,
                    from: this.$route.query.from
                  }
                })
              } else if (v === 'fileToFiled') {
                this.exportField(secondRes.data.data.id)
              } else if (v === 'excelToPdf') {
                this.exportExcelFn(excelAry)
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      exportField(id) {
        let url = this.$resource.exportFields.replace('{recordId}', id)
        this.$axios({
          url: url,
          method: 'get',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: localStorage.getItem(
              'BAILIAN-SHIBIE-TOKEN'
            )
          },
          //转成二进制，一定要加，不加文件无法打开
          responseType: 'blob'
        }).then(res => {
          this.$utils.exportFile(res.data, '通用字段表', 'excel')
        })
      },
      startCheck(resId) {
        let url = this.$resource.startCheck
        return this.$axios({
          url: url,
          method: 'post',
          data: {
            checkVoList: this.verifyList,
            customerInfo: {
              customerCode: '',
              customerName: '',
              remark: ''
            },
            waybillNo:
              this.result.waybillInfo.certiNo !== null
                ? this.result.waybillInfo.certiNo
                : '',
            headResId: this.headResId
          },
          transformResponse: [
            function (data) {
              // 对 data 进行任意转换处理
              // console.log(data)
              let result = JSON.parse(data)
              let obj = {},
                obj2 = {}
              //certificateInfos
              if (result.data.recoResult.certificateInfos) {
                // 提单类型,保存属性
                result.data.recoResult.certificateInfos.forEach(
                  item => {
                    Object.keys(item.certificateInfo).forEach(
                      x => {
                        if (obj[x]) {
                          obj[x].push(
                            item.certificateInfo[x]
                          )
                        } else {
                          let ary = []
                          ary.push(
                            item.certificateInfo[x]
                          )
                          obj[x] = ary
                        }
                      }
                    )
                  }
                )
              }
              result.data.recoResult.certificateInfos = obj

              //goodsinfos
              if (result.data.recoResult.goodsInfos) {
                // 提单类型,保存属性
                result.data.recoResult.goodsInfos.forEach(item => {
                  Object.keys(item.goodsInfo).forEach(x => {
                    if (obj2[x]) {
                      obj2[x].push(item.goodsInfo[x])
                    } else {
                      let ary = []
                      ary.push(item.goodsInfo[x])
                      obj2[x] = ary
                    }
                  })
                })
              }
              result.data.recoResult.goodsInfos = obj2
              return result
            }
          ]
        })
      },
      exportExcelFn(arr) {
        //console.log(arr, '123123123')
        if (arr.length > 0) {
          let url = this.$resource.exportExcelCertiFile
          this.$axios({
            url: url,
            method: 'post',
            data: {
              certiFileVoList: [
                {
                  category: '',
                  certiNo: '',
                  folderName: '',
                  resIdList: arr.map(e => {
                    return e.id
                  })
                }
              ],
              recordId: '',
              compress: '',
              createFolder: '',
              mergeInvoiceEtc: ''
            },
            responseType: 'blob'
          })
            .then(res => {
              let day = new Date()
              let time = day.format('yyyyMMdd/hh:mm:ss')
              this.$utils.exportFile(res.data, time, 'zip')
              this.$refs.exportButtonRef.end()
              this.$message.success('导出成功')
            })
            .catch(() => { })
        } else {
          this.$message.error('没有excel文件可以导出')
        }
      },
      checkWarning() {
        //类型校验
        let types = ['发票', '箱单', '合同']
        let arr = []
        types.forEach(item => {
          if (
            _.findIndex(this.checkVoList, { categoryName: item }) == -1
          ) {
            arr.push(item)
          }
        })
        this.warning = arr.length
          ? '一套单证校验，' + arr.join('、') + '是必备文件'
          : ''
      },
      selectCertificate() {
        if (this.$route.path.includes('endoc') === true) {
          this.endoc = true
        } else {
          this.endoc = false
        }

        let url = this.$resource.selectCertificate
        return this.$axios({
          url: url,
          method: 'post',
          data: {
            checkVoList: this.verifyList,
            type: this.endoc ? 1 : 3
          }
        })
      }
    },
    components: {
      Bread,
      searchFile,
      deleteAll,
      uploadFile,
      tableSocketProcess,
      tableSocketResult,
      tableDataDelete
      // startVerify
    }
  }
</script>
<style>
  @import "./documentIndex.css";

  .shugang {
    width: 1px;
    height: 8px;
    background: #d8d8d8;
    border-radius: 1px;
    display: inline-block;
    margin: 0 10px;
    /* position:relative;
																																																																																																																																																	                                                                          top: 30px; */
  }

  .el-date-editor .el-range-separator {
    color: #191931;
    padding: 0px;
  }

  .el-loading-mask {
    position: fixed;
    height: 100%;
  }
</style>